module.exports = __webpack_public_path__ + "static/media/logoPrefeituraMunicipalPalmas.81a3666d.png";